export interface IAvailableActions {
  canSendRemoteCreditAuth: boolean;
  canSendRemoteElectronicConsent: boolean;
  canAssignUtility: boolean;
  canRunCreditCheck: boolean;
  canReconcileEpc: boolean;
  canRunEpcCalculation: boolean;
  canSendContract: boolean;
  canRunResiPaymentCapture: boolean;
  canUpdatePaymentMethod: boolean;
  canEditCustomerDetails: boolean;
  canViewMostRecentInvoice: boolean;
  canContinueWithNewCustomer: boolean;
  canViewCustomerDocuments: boolean;
  viewProductionPortal: boolean;
  canSyncDocusignDocuments: boolean;
  canViewSalesforceAccount: boolean;
  canSubmitScheduleA1: boolean;
  canApproveScheduleA1: boolean;
  canSubmitDesignModification: boolean;
}

export class AvailableActions implements IAvailableActions {
  canSendRemoteCreditAuth = false;
  canSendRemoteElectronicConsent = false;
  canAssignUtility: boolean;
  canRunCreditCheck = false;
  canReconcileEpc = false;
  canRunEpcCalculation = false;
  canSendContract: boolean;
  canRunResiPaymentCapture = false;
  canUpdatePaymentMethod = false;
  canEditCustomerDetails = false;
  canViewMostRecentInvoice = false;
  canContinueWithNewCustomer = false;
  canViewCustomerDocuments = false;
  viewProductionPortal = false;
  canSyncDocusignDocuments: boolean;
  canViewSalesforceAccount: boolean;
  canSubmitScheduleA1: boolean;
  canApproveScheduleA1: boolean;
  canSubmitDesignModification: boolean;
}
